var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardTableFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 16.5H3.5v4h17v-4h-1.202V15H21l.102.005A1 1 0 0122 16v5a1 1 0 01-.898.995L21 22H3a1 1 0 01-.995-.898L2 21v-5a1 1 0 011-1h1.75v1.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.799 2a1 1 0 011 1v14.797a1 1 0 01-1 1H7.25a1 1 0 01-1-1V3a1 1 0 011.001-1h9.548zM12.25 7.114c-.145-.152-.347-.152-.5 0-.153.153-1.516 1.583-1.516 1.583l-.023.026c-.243.263-.71.77-.711 1.41 0 .789.563 1.445 1.375 1.445.197 0 .372-.033.528-.092l-.287 1.206a.25.25 0 00.243.308h1.285a.25.25 0 00.243-.308l-.29-1.218c.17.067.35.104.528.104.813 0 1.375-.656 1.375-1.444 0-.657-.492-1.18-.75-1.445l-1.5-1.575z",
    fill: "currentColor"
  })));
}
SvgCardTableFilled.displayName = 'CardTableFilled';
export default SvgCardTableFilled;